// extracted by mini-css-extract-plugin
export default {"PasswordResetPhone":"yr_a bhi_qr bhi_a bhi_w bhi_ea bhi_tj"};